<section class="dark">
    <div class="contained" *ngIf="worktop && (worktopConfig || worktopConfig === null)">
        <component-solid-surface-config [worktop]="worktop" [worktopConfigUuid]="worktopConfigUuid" [worktopConfig]="worktopConfig" [readOnly]="readOnly" (saveEmitter)="saveConfig($event)"></component-solid-surface-config>
    </div>

    <h4 class="not-found" *ngIf="error">Worktop Configuration Not Found.</h4>
</section>